/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */
import { WideDivider } from '@boi/core/lib';
import { colors } from '@boi/core/lib/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { ExternalLink } from '../../components/ExternalLink/ExternalLink';
import { commonFormStylesIdentifier } from '../../constants';
import { dividerColor } from '../../constants/colors';
import { CALL_TEXT, CLAIM_TEXT, EMAIL_TEXT, EMERGENCY_TEXT, POST_TEXT } from '../../constants/submitClaimConstants';
import { isEdgeBrowser } from '../../utils/utils';


interface Props {
  className: string,
  label: string,
  info: any,
  icon: FontAwesomeIcon,
  contactData: string
}

const ContactCard = ({ className, label, info, icon, contactData }: Props) => {

  const paragraphLinkText = `Opens in a new tab`;

  // eslint-disable-next-line complexity
  const renderLink = () => {
    switch (label) {
      case CALL_TEXT:
        return <a href={`tel:${contactData}`}>{contactData}</a>;
      case EMAIL_TEXT:
        return <a href={`mailto:${contactData}`}>Send Email</a>;
      case CLAIM_TEXT:
        return <ExternalLink url={contactData} text="Find Out more"/>;
      case EMERGENCY_TEXT:
        return <>Call <a href={`tel:${contactData}`}>{contactData}</a></>;
      default:
        return <span>{''}</span>;
    }
  };

  return (
    <div>
      <div className={`${className}__content`}>
        <FontAwesomeIcon className="signupIcon" icon={icon} size="2x" color={colors.primaryColor}
                         alt={`${label} icon`} />
      </div>
      <h2>
        {label}
      </h2>
      {label !== POST_TEXT &&
        <p aria-label={paragraphLinkText}>
          {isEdgeBrowser && <span
            className="externalLinkText">{paragraphLinkText}</span>}
          {renderLink()}
        </p>}
      <div>
        {info}
      </div>
      <div className={`${commonFormStylesIdentifier}__dividerContainer`}>
        <WideDivider color={dividerColor} height={1} />
      </div>
    </div>
  );
};

export default ContactCard;
